import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { destinazioneCorrente, loginConNext } from '@/lib/nav';
import PrimoAccessoPage from '@/pages/PrimoAccessoPage';
import { Clock } from 'lucide-react';

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#efe8da]" data-testid="loading-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#12100c] mx-auto" />
          <p className="text-sm text-[#4a4238] mt-3">Caricamento...</p>
        </div>
      </div>
    );
  }

  // Chi arriva da un link e non ha ancora fatto accesso deve poterci tornare dopo.
  if (!user) {
    return <Navigate to={loginConNext(destinazioneCorrente(location))} replace />;
  }

  if (!user.profile?.is_approved) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#efe8da]" data-testid="pending-approval-screen">
        <div className="bg-white rounded-2xl p-8 shadow-sm max-w-md text-center border border-gray-100">
          <div className="w-16 h-16 bg-[#c6a15b]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Clock className="w-8 h-8 text-[#8a6620]" />
          </div>
          <h2 className="font-heading text-xl font-semibold text-[#12100c] mb-2">
            Accesso non attivo
          </h2>
          <p className="text-[#4a4238] text-sm mb-6">
            {user.profile?.blocked_reason
              || "Il tuo accesso al portale non risulta attivo. Se sei un promotore Biounica e pensi si tratti di un errore, contatta Biounica."}
          </p>
          <button
            onClick={logout}
            className="text-[#4a5f43] hover:underline text-sm font-medium"
            data-testid="pending-logout-btn"
          >
            Esci
          </button>
        </div>
      </div>
    );
  }

  // Primo accesso: professione e avvisi su WhatsApp, una volta sola. Vale solo
  // per i promotori: allo staff non serve e non deve intralciare il lavoro.
  if (!user.is_staff && !user.profile?.onboarding_at) {
    return <PrimoAccessoPage />;
  }

  if (requireAdmin && !user.is_admin && !user.is_editor) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
